// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CodeEditor_main__Luqa0 {
  width: 80%;
  margin: auto;
}

.CodeEditor_card__uvYKo {
  width: 100%;
}

.CodeEditor_textAreaPanel__KT47D {
  resize: none;
  height: 75vh;
}

.CodeEditor_cardPanelPadding__\\+OIw1 {
  padding: 0 !important;
}

.CodeEditor_link__jMnWG:hover {
  color: var(--info-color);
  text-decoration: underline;
  cursor: pointer;
}

.CodeEditor_alertTitle__q3IzN {
  margin-left: 1rem;
}

.CodeEditor_alertContainer__7Twyd {
  display: flex;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/components/CodeEditor/CodeEditor.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC","sourcesContent":[".main {\n  width: 80%;\n  margin: auto;\n}\n\n.card {\n  width: 100%;\n}\n\n.textAreaPanel {\n  resize: none;\n  height: 75vh;\n}\n\n.cardPanelPadding {\n  padding: 0 !important;\n}\n\n.link:hover {\n  color: var(--info-color);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.alertTitle {\n  margin-left: 1rem;\n}\n\n.alertContainer {\n  display: flex;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `CodeEditor_main__Luqa0`,
	"card": `CodeEditor_card__uvYKo`,
	"textAreaPanel": `CodeEditor_textAreaPanel__KT47D`,
	"cardPanelPadding": `CodeEditor_cardPanelPadding__+OIw1`,
	"link": `CodeEditor_link__jMnWG`,
	"alertTitle": `CodeEditor_alertTitle__q3IzN`,
	"alertContainer": `CodeEditor_alertContainer__7Twyd`
};
export default ___CSS_LOADER_EXPORT___;
